import * as R from 'ramda';
import { OrderView } from '../../../ordersView.types';

export interface ShouldShowPackStockParams {
  consumeStock?: boolean;
  viewMode?: OrderView;
  isDisablePublicStock?: boolean;
  stockAvailableAmount?: number | null;
}

export const shouldShowPackStock = ({
  viewMode,
  isDisablePublicStock,
  consumeStock = false,
  stockAvailableAmount,
}: ShouldShowPackStockParams) => {
  if (isDisablePublicStock || !consumeStock || R.isNil(stockAvailableAmount)) {
    return false;
  }

  if (viewMode && viewMode === OrderView.FINISHED) {
    return false;
  }

  return true;
};
